"use client";

import { ArrowBackIosNew, Dark2, DarkHorizontal, Search } from "@ellaandil/ui";
import { Container } from "@/components/ui/Container";
import { GeoStatus } from "@/components/ui/GeoStatus";
import { IconButton } from "@/components/ui/IconButton";
import { CartTrigger } from "@/features/cart/CartModal";
import { GeoSelectorTrigger } from "@/features/navigation/GeoSelector";
import { DesktopLinks } from "@/features/navigation/Header/components//DesktopLinks";
import { MobileMenu, MobileMenuTrigger } from "@/features/navigation/Header/components//MobileMenu";
import { HeaderCart } from "@/features/navigation/Header/components/HeaderCart";
import { HeaderSearchInput } from "@/features/search/components/HeaderSearchInput";
import { useSearchModal } from "@/features/search/SearchProvider";
import { useTranslations } from "@/i18n/client";
import { Link, usePathname } from "@/i18n/routing";

export const HeaderContent = () => {
	const t = useTranslations();
	const { toggle: toggleSearch } = useSearchModal();
	const pathname = usePathname();
	const isCheckout = pathname.includes("checkout") && !pathname.includes("summary");

	return (
		<header className="bg-brand-sand-10 h-12 lg:h-24 flex items-center">
			<Container as="div" className="h-full">
				<div className="grid h-12 lg:h-24 grid-cols-3 lg:grid-cols-[1fr_auto_1fr] lg:gap-grid-grid-gutter-xl items-center">
					{isCheckout ? (
						<Link href="/" className="flex items-center p-1.5 gap-1">
							<ArrowBackIosNew className="w-2 h-3" />
							<span className="font-display p-1-5 font-[300] leading-[125%] underline-0 no-underline text-sm">
								{t("header.checkout.back")}
							</span>
						</Link>
					) : (
						<DesktopLinks />
					)}
					{isCheckout ? null : (
						<MobileMenuTrigger className="block lg:hidden font-display justify-self-start">
							{t("header.menu")}
						</MobileMenuTrigger>
					)}
					<MobileMenu />
					<Link href="/" aria-label={t("Ella & Il — home")} className="flex justify-center">
						<DarkHorizontal className="h-6 w-auto block lg:hidden" />
						<Dark2 className="hidden lg:block" width={89} height={64} />
					</Link>
					{isCheckout ? null : (
						<div className="flex justify-end items-center lg:flex-1">
							<HeaderSearchInput className="hidden lg:block lg:flex-1" />
							<IconButton
								icon={Search}
								label={t("Search")}
								variant="ghost-primary"
								size="lg"
								className="size-9 lg:hidden"
								onClick={toggleSearch}
							/>
							<GeoSelectorTrigger asChild>
								<GeoStatus className="hidden lg:flex p-1.5 whitespace-nowrap" />
							</GeoSelectorTrigger>
							<CartTrigger>
								<HeaderCart />
							</CartTrigger>
						</div>
					)}
				</div>
			</Container>
		</header>
	);
};
